const isTracing = () => {
  return typeof global.__traceValue__ === "function";
};

// traceValue_ :: String -> Foreign -> Effect Unit
export function traceValue_(name) {
  return (value) => () => {
    if (isTracing()) {
      global.__traceValue__(name, value);
    }
  };
}

export { isTracing };
